import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerPlanPaymentFailedComponent } from './broker-plan-payment-failed.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { BrokerPlanConnectBrokerModule } from '../broker-plan-connect-broker/broker-plan-connect-broker.module';
import { MatDividerModule } from '@angular/material/divider';
import { NullCheckModule, PrecisionModule } from '@app/_shared/pipes';
import { EarningsFormatterModule } from '@app/_shared/pipes/earnings-formatter/earnings-formatter.module';



@NgModule({
  declarations: [BrokerPlanPaymentFailedComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    BrokerPlanConnectBrokerModule,
    MatDividerModule,
    NullCheckModule,
    PrecisionModule,
    EarningsFormatterModule
  ],
  exports: [BrokerPlanPaymentFailedComponent]
})
export class BrokerPlanPaymentFailedModule { }
